export { TabProvider } from '../src/Common/Tabs/TabProvider';
